export default {
    stoptblogo: require('./logo5.png'),
    cdiclogo:require('./cdic-logo.png')
}